import {
  ChangeDetectorRef,
  Component,
  HostListener,
  Inject,
  OnInit,
} from '@angular/core';
import { DIALOG_DATA } from '@ansys-internal/awf-angular/shared';
import {
  AWCTableCellText,
  AWCTableColumns,
  AWCTableRow,
  TableCellAlign,
  TableCellTypes,
  TableComponent,
} from '@ansys-internal/awc-angular/tables';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { CommonModule } from '@angular/common';
import { StaticRequirementSolved } from '../../../../api/models/StaticRequirementSolved';

@Component({
  selector: 'app-capability-curve-error-dialog',
  imports: [TableComponent, CommonModule, ScrollingModule],
  templateUrl: './capability-curve-error-dialog.component.html',
  styleUrls: ['./capability-curve-error-dialog.component.scss'],
})
export class CapabilityCurveErrorDialogComponent implements OnInit {
  protected height: number = 0;
  protected columns: AWCTableColumns[] = [
    { id: 'point', header: 'Point', align: TableCellAlign.LEFT, width: 200 },
    { id: 'error', header: 'Error', align: TableCellAlign.LEFT },
  ];
  protected rows: AWCTableRow[] = [];
  protected loading: boolean = true;

  constructor(
    @Inject(DIALOG_DATA)
    private data: { result: StaticRequirementSolved },
    private _cdr: ChangeDetectorRef
  ) {
    const errors = (this.data.result.capability_curve as any)?.errors ?? {};

    this.rows = Object.entries(errors).map(([point, error], index) => {
      return {
        id: index.toString(),
        cells: [
          {
            value: point,
            type: TableCellTypes.TEXT,
          } as AWCTableCellText,
          {
            value: error,
            type: TableCellTypes.TEXT,
          } as AWCTableCellText,
        ],
      };
    });
  }

  ngOnInit(): void {
    this.calculateHeight();

    setTimeout(() => {
      this.loading = false;
      this._cdr.detectChanges();
    });
  }

  @HostListener('window:resize')
  onResize(): void {
    this.calculateHeight();
  }

  private calculateHeight(): void {
    const viewportHeight = window.innerHeight;
    this.height = Math.max(viewportHeight * 0.8 - 170, 0);
  }
}

